// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3LWth","header":"MergedInvoice_header__12gLW"};